const SouscriptionCustomerExtraForm = () => null;

export default SouscriptionCustomerExtraForm;
